module.exports = "<p>\n  property-grid works!\n</p>\n"